import {API_URLS} from '@/const';
import {http} from '@/helper';

export const buyCryptoCardApi = {
  getAnnuouncement(query) {
    return http.get(API_URLS.PUBLIC_B2C_BANNER, {
      query,
      formatter: (data) => {
        return (data.items && data.items[0]) || {};
      },
    });
  },
  getConfigs(query, isLogin) {
    return http.get(isLogin ? API_URLS.BUY_CRYPTO_CONFIG : API_URLS.PUBLIC_BUY_CRYPTO_CONFIG, {query});
  },
  getPricing(query, isLogin) {
    return http.get(isLogin ? API_URLS.BUY_CRYPTO_PRICING : API_URLS.PUBLIC_BUY_CRYPTO_PRICING, {query});
  },
  // b2c订单查询
  getOrderList(query) {
    return http.get(API_URLS.B2C_ORDERS, {query});
  },
  getAdBannerList(query, isLogin) {
    return http.get(isLogin ? API_URLS.ACTIVITY_CONTENTS_VIEW_LOGIN : API_URLS.ACTIVITY_CONTENTS_VIEW_LOGOUT, {query});
  },
  //  银行卡列表查询
  getPaymentList(query) {
    return http.get(API_URLS.B2C_BANK_CARD_LIST, {query});
  },
  // 设置银行卡为默认卡
  setDefaultPayment(query) {
    return http.put(API_URLS.B2C_BANK_CARD_SET_DEFAULT, {query});
  },
  // 解绑银行卡
  deletePayment(query) {
    return http.delete(API_URLS.B2C_BANK_CARD, {query});
  },
  postPlaceOrder(params) {
    return http.post(API_URLS.B2C_PLACE_ORDER, {params});
  },
  postBindCardPlaceOrder(params) {
    return http.post(API_URLS.B2C_BIND_CARD_PLACE_ORDER, {params});
  },
  postKycValidate(params) {
    return http.post(API_URLS.B2C_KYC_VALIDATE, {params});
  },
  getKycMissingConfig(query) {
    return http.get(API_URLS.B2C_KYC_MISSING_CONFIG, {query});
  },
  // 风控检查
  checkRisk(query) {
    return http.get(API_URLS.FIAT_RISK_CHECK, {query});
  },
  // 将订单状态设置成失败
  creditOrderFailed(params) {
    return http.post(API_URLS.B2C_CREDIT_ORDER_FAILED, {params});
  },
  getDepositAddress(query) {
    return http.get(API_URLS.OTC_DEPOSIT_ADDRESS, {query});
  },
  getLegendQuestionnaires(query) {
    return http.get(API_URLS.OTC_LEGEND_QUESTIONNAIRE, {query});
  },
  /**
   * @returns {Promise<{ data?: Record<string, any>, error?: {code: string | number, message: string}, reply: Record<string, any>}>}
   */
  getPhemexAndLegendKYCStatus() {
    return http.get(API_URLS.SUBMIT_OTC_LEGEND_QUESTIONNAIRE, {});
  },
  /** 提交Legend问卷调查 */
  postLegendQuestionnaire(params) {
    return http.post(API_URLS.SUBMIT_OTC_LEGEND_QUESTIONNAIRE, {params: {needSync: true, ...params}});
  },
  /**
   * 获取mercuryo新绑定还未交易过的卡
   * @param {number} [pageSize]
   * @returns {Promise<HttpResponse>}
   */
  getMercuryoNewBindedCards(pageSize) {
    return http.get(API_URLS.B2C_BANK_CARD_LIST, {query: {pageNum: 0, pageSize: pageSize || 3, channelName: 'Mercuryo', status: 'NEW', sortField: 'update_time', side: 'sell'}});
  },
  /**
   * 解绑新绑定还未交易过的卡
   * @returns {Promise<HttpResponse>}
   */
  unbindMercuryoNewBindedCard(cardId) {
    return http.delete(API_URLS.DELETE_B2C_BANK_CARD, {query: {cardId}});
  },
  getPaybisOrderList(query) {
    return http.get(API_URLS.PAYBIS_ORDERS, {query});
  },
  postPaybisOrder(params) {
    return http.post(API_URLS.PAYBIS_PLACE_ORDER, {params});
  },
  postRiskCheck(params) {
    return http.post(API_URLS.B2C_RISK_CHECK, {params});
  },
};
